import { Component, Input, QueryList, ContentChildren, AfterContentInit } from '@angular/core';

import { DashTabTitleDirective } from './dash-tab-title.directive';
import { DashTabContentDirective } from './dash-tab-content.directive';

@Component({
    selector: 'aa-dash-tab',
    template: '',
    styleUrls: [],
    standalone: false
})
export class DashTabComponent implements AfterContentInit
{
    @Input() id: number;
    @Input() title: string;
    @Input() active: boolean = false;
    @Input() disabled: boolean = false;
    @ContentChildren(DashTabTitleDirective, { descendants: false }) titleTemplates: QueryList<DashTabTitleDirective>;
    @ContentChildren(DashTabContentDirective, { descendants: false }) contentTemplates: QueryList<DashTabContentDirective>;
    public titleTpl: DashTabTitleDirective | null;
    public contentTpl: DashTabContentDirective | null;

    constructor() { }

    ngAfterContentInit ()
    {
        this.titleTpl = this.titleTemplates.first;
        this.contentTpl = this.contentTemplates.first;
    }
}
